import BaseCommand from "@/models/api/commands/BaseCommand";

export interface EditOwnerParams {
  id: number;
  share: number;
  ownerType: number;
  name: string;
}

export class EditOwnerCommand extends BaseCommand {
  CommandName = "EditOwner";
  Command: EditOwnerParams;
  constructor(sessionId: string, operationId: string, params: EditOwnerParams) {
    super(sessionId, operationId);
    this.Command = params;
  }
}
